var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-6"},[_c('div',{staticClass:"d-flex justify-center align-center"},[_c('v-card',{staticClass:"pa-4",attrs:{"min-width":"600px"}},[_c('add-device-page')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }